import React from 'react';
import u from '../utilities/Utilities';
import AppLayout from '../components-app/AppLayout';
import {Step,LoadGraphic,Databox,Segment,MobileMenu,PageMenu} from '../components-static/Common';
import {Button,Date,Select,TextButton,Color,Time} from '../components-static/Input';
import {InOutOptions,LineThickness,PointRadius,ShowPointValues,Fill,LineType,OccupancyQueryType} from '../data/ReportOptions';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Doughnut,Line,Bar} from 'react-chartjs-2';
import {SketchPicker} from 'react-color';
import "../styles/reports.scss";
import "../styles/common.scss";

const defaultColor="#07abf2";
const presetColors=["#07abf2","#54b848","#ffd05b","#fd8469","#3a99d7","#90dfaa","#324a5e"];
import Measure from 'react-measure';

export default class Reports extends React.Component{

    state={
        tenantOptions:[],
        spreadsheets:[
            {
                title:"Turnstile Diagnostics Report",
                description:"Generates a spreadsheet report of active turnstiles for diagnostics purposes",
                url:"/api/download-turnstile-diagnostics-report",
                input:[
                    {ref:"startDate",label:"Start",type:"date",range:[2,1],rules:{defaultValue:moment().subtract(1,"months").format("YYYY-MM-DD")}},
                    {ref:"endDate",label:"End",type:"date",range:[2,1],rules:{defaultValue:moment().format("YYYY-MM-DD")}},
                ],
                image:"/images/reports/excel.png",
                button:"turnstileDiagnostics",
            },
        ],
        selected:"none",
        buttons:[
            {permission:true,scroll:"regular",index:"timeAttendance",icon:"/images/reports/analytics.png",label:"Time & Attendance"},
            {permission:true,scroll:"regular",index:"accessActivity",icon:"/images/reports/analytics.png",label:"Access Activity"},
            {permission:true,scroll:"regular",index:"appointmentActivity",icon:"/images/reports/analytics.png",label:"Appointment Activity"},
            {permission:(u.getSuperUser()),scroll:"regular",index:"turnstileDiagnostics",icon:"/images/reports/analytics.png",label:"Turnstile Diagnostics"},
        ],
        pageMenuButtons:[],
    };

    pageData={
        title:"Reports",
        permission:"combined",
        permissionField:"reports",
        url:"/reports",
    };

    scrollAnchor=u.getKey();

    componentDidMount=()=>{
        this.getTenantOptions();
    }

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    }

    getTenantOptions=()=>{
        if(u.getSuperUser()){
            u.post({
                url:"/api/get-tenant-options",
                data:{},
                success:(tenantOptions)=>{
                    tenantOptions.unshift({value:"all",label:"All"});
                    this.setState({tenantOptions:tenantOptions})
                },
                error:(error)=>{this.setState({error:error})}
            });
        }
        else{
            this.setState({
                tenantOptions:[{value:u.getTenantID(),label:u.getTenantName()}]
            });
        }
    }

    onSelected=(type,target)=>{
        if(this.state.selected != target){
            this.setState({selected:target,selectedType:type});
            this.refs[type].scroll();
        }
        else{
            this.setState({selected:"none",selectedType:"none"});
        }
    }

    render(){
        const tenantOptions = this.state.tenantOptions;
        const selected=this.state.selected;
        const selectedType = this.state.selectedType;

        return (
            <AppLayout title={this.pageData.title} requiredPermission={this.pageData.permission} requiredField={this.pageData.permissionField} url={this.pageData.url}>

            <div className="report-content-buttons">
                <div className="report-content-segment">
                    <h3 className="mobile-hide">Reports</h3>
                    <Segment ref="regular" active={(selectedType == "regular")} align="center" scrollAnchor={this.scrollAnchor}>
                        {
                            (selected == "timeAttendance") ? <TimeAttendanceReport tenantOptions={tenantOptions}/> : ""
                        }
                        {
                            (selected == "accessActivity") ? <AccessActivityReport tenantOptions={tenantOptions}/> : ""
                        }
                        {
                            (selected == "appointmentActivity") ? <AppointmentActivityReport tenantOptions={tenantOptions}/> : ""
                        }
                        {
                            this.state.spreadsheets.map(
                                (item,index)=>{
                                    if(item.button != selected){
                                        return (<span key={index}/>)
                                    }
                                    return (<SpreadsheetReport key={index} content={item} tenantOptions={tenantOptions}/>)
                                }
                            )
                        }
                    </Segment>
                    <div className="report-button-segment">
                        {
                            this.state.buttons.map(
                                (item,index)=>{
                                    return (
                                        <div className={"report-button" + ((selected == item.index) ? " selected" : "")} id={item.index} key={index}  onClick={()=>this.onSelected("regular",item.index)}>
                                            <img src={item.icon} className="report-button-image"/>
                                            <div className="report-button-label">{item.label}</div>
                                        </div>
                                    )
                                }
                            )
                        }
                    </div>
                </div>
            </div>

            </AppLayout>
        )
    }
}


/************** App Graphical Reports ****************/

class TimeAttendanceReport extends React.Component{

    state={
        content:{
            title:"Time Attendance Report",
            description:"Graphical summary of earliest check-in and latest check-out between the respective dates",
            url:"/api/get-time-attendance-report",
            input:[
                {ref:"tenantID",label:"Tenant",type:"select",options:this.props.tenantOptions},
                {ref:"userID",label:"User",type:"select",options:[]},
                {ref:"startDate",label:"Start",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
                {ref:"endDate",label:"End",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
            ],
            quantifier:"Time",
        },
        additionalText:[],
    };

    data=[];

    graphModifier={
        yAxesTicks:{
            stepSize:1,
            callback:(value)=>{return u.convertLinearToTime(value)}
        },
        tooltipsLabel:(tooltipItem,data)=>{
            const label = data.datasets[tooltipItem.datasetIndex].label;
            return label + " Time: " + u.convertLinearToTime(tooltipItem.value);
        }
    };

    onChangeInput=(value,label,index,option)=>{
        if(label == "tenantID"){
            this.getUserOptions(value);
        }
        let content = this.state.content;
        content.input[index].value=value;
        this.setState({content:content});
    }

    getUserOptions=(tenantID)=>{
        u.post({
            url:"/api/get-staff-options",
            data:{tenantID:tenantID},
            success:(userOptions)=>{
                let content = this.state.content;
                content.input[1].options = userOptions;
                this.setState({content:content});
            },
            error:(error)=>{this.setState({error:error})}
        });
    };

    onData=(query,callback)=>{
        if(typeof query == "undefined" || query.skip){
            return 0;
        }
        this.data.push({query:query,callback:callback});
        this.setState({additionalText:["Attended: " + callback.attended + " Days","Present: " + callback.present + " Hours","Average: " + (parseFloat(callback.present) / parseFloat(callback.attended)) + " Hrs/Day"]});
    }

    onDownload=()=>{
        //Remove options from query
        this.refs['graph'].onLoading(true,"Preparing spreadsheet...");
        const queryArr = this.state.content.input.map((item)=>{return {field:item.ref,value:(item.value) ? item.value : item.rules.defaultValue}});

        let query={};
        for(var i=0; i<queryArr.length; i++){
            query[queryArr[i].field]=queryArr[i].value;
        };

        u.autoDownload({
            url:"/api/download-time-attendance-report",
            data:{
                query:query
            },
            success:()=>{
                this.refs['graph'].onLoading(false,"");
            },
            error:(error)=>{
                this.refs['graph'].onLoading(false,"");
                this.refs['graph'].onError(error);
            }
        });
    }

    onResetData=()=>{
        this.data=[];
        this.setState({additionalText:[]});
    }

    render=()=>{
        return (
            <GraphReport ref="graph" content={this.state.content} smallMode={this.props.smallMode} onChangeInput={this.onChangeInput} onData={this.onData} additionalText={this.state.additionalText} onReset={this.onResetData} autoQuery={this.props.autoQuery}
                         graphModifier={this.graphModifier} onDownload={this.onDownload}/>
        )
    }
}
TimeAttendanceReport.propTypes={
    tenantOptions:PropTypes.array,
    autoQuery:PropTypes.object,
};

class AccessActivityReport extends React.Component{

    state={
        content:{
            title:"Access Activity Report",
            description:"Graphical summary of turnstile access trends between the respective dates",
            url:"/api/get-access-report",
            input:[
                {ref:"tenantID",label:"Tenant",type:"select",options:this.props.tenantOptions},
                {ref:"startDate",label:"Start",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
                {ref:"endDate",label:"End",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
            ],
            quantifier:"Events",
        },
        additionalText:[],
    };

    data=[];

    graphModifier={
        yAxesTicks:{
            /*stepSize:1,
            callback:(value)=>{return u.convertLinearToTime(value)}*/
        },
        tooltipsLabel:(tooltipItem,data)=>{
            const label = data.datasets[tooltipItem.datasetIndex].label;
            return label + " Events: " + tooltipItem.value;
        }
    };

    onChangeInput=(value,label,index,option)=>{
        let content = this.state.content;
        content.input[index].value=value;
        this.setState({content:content});
    }

    onData=(query,callback)=>{
        if(typeof query == "undefined" || query.skip){
            return 0;
        }
        this.data.push({query:query,callback:callback});
    }

    onDownload=()=>{
        //Remove options from query
        this.refs['graph'].onLoading(true,"Preparing spreadsheet...");
        const queryArr = this.state.content.input.map((item)=>{return {field:item.ref,value:(item.value) ? item.value : item.rules.defaultValue}});

        let query={};
        for(var i=0; i<queryArr.length; i++){
            query[queryArr[i].field]=queryArr[i].value;
        };

        u.autoDownload({
            url:"/api/download-access-report",
            data:{
                query:query
            },
            success:()=>{
                this.refs['graph'].onLoading(false,"");
            },
            error:(error)=>{
                this.refs['graph'].onLoading(false,"");
                this.refs['graph'].onError(error);
            }
        });
    }

    onResetData=()=>{
        this.data=[];
        this.setState({additionalText:[]});
    }

    render=()=>{
        return (
            <GraphReport ref="graph" content={this.state.content} smallMode={this.props.smallMode} onChangeInput={this.onChangeInput} onData={this.onData} additionalText={this.state.additionalText} onReset={this.onResetData} autoQuery={this.props.autoQuery}
                         graphModifier={this.graphModifier} onDownload={this.onDownload}/>
        )
    }
}
AccessActivityReport.propTypes={
    tenantOptions:PropTypes.array,
    autoQuery:PropTypes.object,
};

class AppointmentActivityReport extends React.Component{

    state={
        content:{
            title:"Appointment Activity Report",
            description:"Graphical summary of visitor appointment trends between the respective dates",
            url:"/api/get-appointment-report",
            input:[
                {ref:"tenantID",label:"Tenant",type:"select",options:this.props.tenantOptions},
                {ref:"userID",label:"User",type:"select",options:[]},
                {ref:"startDate",label:"Start",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
                {ref:"endDate",label:"End",type:"date",range:[5,2],rules:{defaultValue:moment().format("YYYY-MM-DD")},lock:true},
            ],
            quantifier:"Events",
        },
        additionalText:[],
    };

    data=[];

    graphModifier={
        yAxesTicks:{
            /*stepSize:1,
            callback:(value)=>{return u.convertLinearToTime(value)}*/
        },
        tooltipsLabel:(tooltipItem,data)=>{
            const label = data.datasets[tooltipItem.datasetIndex].label;
            return label + " Events: " + tooltipItem.value;
        }
    };

    getUserOptions=(tenantID)=>{
        u.post({
            url:"/api/get-staff-options",
            data:{tenantID:tenantID},
            success:(userOptions)=>{
                let content = this.state.content;
                userOptions.unshift({value:"all",label:"All"});
                content.input[1].options = userOptions;
                this.setState({content:content});
            },
            error:(error)=>{this.setState({error:error})}
        });
    };

    onChangeInput=(value,label,index,option)=>{
        if(label == "tenantID"){
            this.getUserOptions(value);
        }

        let content = this.state.content;
        content.input[index].value=value;
        this.setState({content:content});
    }

    onData=(query,callback)=>{
        if(typeof query == "undefined" || query.skip){
            return 0;
        }
        this.data.push({query:query,callback:callback});
    }

    onDownload=()=>{
        //Remove options from query
        this.refs['graph'].onLoading(true,"Preparing spreadsheet...");
        const queryArr = this.state.content.input.map((item)=>{return {field:item.ref,value:(item.value) ? item.value : item.rules.defaultValue}});

        let query={};
        for(var i=0; i<queryArr.length; i++){
            query[queryArr[i].field]=queryArr[i].value;
        };

        u.autoDownload({
            url:"/api/download-appointment-report",
            data:{
                query:query
            },
            success:()=>{
                this.refs['graph'].onLoading(false,"");
            },
            error:(error)=>{
                this.refs['graph'].onLoading(false,"");
                this.refs['graph'].onError(error);
            }
        });
    }

    onResetData=()=>{
        this.data=[];
        this.setState({additionalText:[]});
    }

    render=()=>{
        return (
            <GraphReport ref="graph" content={this.state.content} smallMode={this.props.smallMode} onChangeInput={this.onChangeInput} onData={this.onData} additionalText={this.state.additionalText} onReset={this.onResetData} autoQuery={this.props.autoQuery}
                         graphModifier={this.graphModifier} onDownload={this.onDownload}/>
        )
    }
}
AppointmentActivityReport.propTypes={
    tenantOptions:PropTypes.array,
    autoQuery:PropTypes.object,
};


/************ Exported Reports & Tools ***************/

export class SpreadsheetReport extends React.Component{

    state={
        loadText:"Generating Report...",
        loading:false,
        step:0,
    };

    onDownload=(data)=>{
        this.setState({loading:true,loadText:"Generating Report...",error:""});
        u.post({
            url:this.props.content.url,
            data:data,
            success:function(data){
                if(data.ready == true) {
                    this.setState({loadText: "Downloading Report..."});
                    u.download(data.filename, data.filestamp,
                        function () {
                            this.setState({loading: false, step:2});
                        }.bind(this),
                        function (error) {
                            this.setState({loading: false, error: error});
                        }.bind(this));
                }
                else{
                    this.setState({loading:false,step:1,estimation:data.estimation});
                }
            }.bind(this),
            error:function(error,status){
                this.setState({error:error,loading:false});
            }.bind(this)
        })
    }

    onValidate=()=>{
        let keys = this.props.content.input;
        let data = {};
        for(var i=0; i<keys.length; i++){
            const item = keys[i].ref;
            const userInput = this.refs[item].validate();
            if(!userInput.valid){
                this.setState({error:userInput.value});
                return 0;
            }

            if(item == "endDate"){
                //Always comes with a startDate
                const startDate=this.refs['startDate'].validate();
                if(moment(userInput.value).isBefore(startDate.value)){
                    this.setState({error:"End Date cannot be before Start Date"});
                    return 0;
                }
            }

            data[item]=userInput.value;
        }

        this.onDownload(data);
    }

    onBack=()=>{
        this.setState({step:0});
    }

    render=()=>{
        const content = this.props.content;
        return(
            <div className={"report-container"}>
                <div className="report-header">
                    <div className="report-icon">
                        <img src={(content.image) ? content.image : "/images/reports/excel.png"}/>
                    </div>
                    <h3 className="report-title">{content.title}</h3>
                </div>

                <Step active={(this.state.step == 0)}>
                    <div style={{position:"relative"}}>
                        <div>
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <div className="report-error">{this.state.error}</div>
                            <div className="report-description">{content.description}</div>
                            <div className="report-input">
                                {
                                    content.input.map(
                                        (item,index)=>{
                                            return (<ReportInputItem key={index} ref={item.ref} content={item}/>)
                                        }
                                    )
                                }
                            </div>
                        </div>
                        <div className="report-buttons">
                            <Button onClick={this.onValidate} type="medium">Download</Button>
                        </div>
                    </div>
                </Step>

                <Step active={(this.state.step == 1)}>
                    <div className="report-content">
                        <div className="report-estimate">
                            <h3>Report creation started and will take <span className="text-emphasis">~{this.state.estimation} minutes</span> to generate</h3>
                            <div className="report-note">Note. The report will be sent to your email upon creation</div>
                        </div>
                        <div className="report-buttons">
                            <Button onClick={this.onBack} type="medium">Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={(this.state.step == 2)}>
                    <div className="report-content">
                        <div className="report-estimate">
                            <h3>Report successfully generated</h3>
                            <div className="report-note">Note: If your download does not automatically start, please click <span className="text-emphasis" style={{cursor:"pointer"}} onClick={this.onDownload}>here</span></div>
                        </div>
                        <div className="report-buttons">
                            <Button onClick={this.onBack} type="medium">Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}
SpreadsheetReport.propTypes={
    content:PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        input: PropTypes.array.isRequired,
        image: PropTypes.string,
    })
};

export class GraphReport extends React.Component{

    state={
        step:0,
        error:"",
        loading:false,
        loadText:"",
        showSettings:false,
        addData:false,
        settings:[
            {ref:"borderColor",label:"Line Color",type:"color",value:defaultColor},
            {ref:"borderWidth",label:"Line Size",type:"select",options:LineThickness,value:"1"},
            {ref:"lineType",label:"Line Type",type:"select",options:LineType,value:"solid"},
            {ref:"fill",label:"Fill",type:"select",options:Fill,value:false},
            {ref:"pointRadius",label:"Point Size",type:"select",options:PointRadius,value:"2"},
            {ref:"pointBackgroundColor",label:"Point Color",type:"color",value:defaultColor},
            {ref:"showPointValue",label:"Show Point Value",type:"select",options:ShowPointValues,value:false},
        ],
        graphData:{
            datasets:[],
            labels:[],
        },
        options:{
            showLines:true,
            spanGaps:false,
            legend:{
                display:true,
                labels:{
                    boxWidth:(this.props.smallMode ? 20 : 40),
                    padding:(this.props.smallMode ? 5 : 10),
                }
            },
            scales:{
                xAxes:[{
                    ticks: {
                        autoSkip: true,
                        autoSkipPadding: 20,
                    }
                }],
                yAxes: [{
                    ticks: this.props.graphModifier.yAxesTicks
                }]
            },
            animation:{
                onComplete:function () {
                    var ctx = this.chart.ctx;
                    this.data.datasets.forEach(function (dataset) {
                        if(dataset.queryType != "mean"){
                            if(dataset.showPointValue) {
                                ctx.font = "9px regular";

                                let max = 0;
                                let min = 0;

                                for (m = 0; m < dataset.data.length; m++) {
                                    const current = dataset.data[m];
                                    if (m > max) {
                                        max = m;
                                    }
                                    if (m < min) {
                                        min = m;
                                    }
                                }

                                for (var d = 0; d < dataset.data.length; d++) {
                                    for (var k in dataset._meta) {
                                        if(dataset._meta[k].data[d]) {
                                            var m = dataset._meta[k].data[d]._model;
                                            const yScale = dataset._meta[k].data[d]._chart.boxes[3].ticks;
                                            const scaleTopThreshold = parseFloat(yScale[0]) - ((parseFloat(yScale[0]) - parseFloat(yScale[1])) / 5);
                                            const scaleBottomThreshold = parseFloat(yScale[yScale.length - 1]) + ((parseFloat(yScale[yScale.length - 2]) - parseFloat(yScale[yScale.length - 1])) / 5);
                                            const current = dataset.data[d];
                                            let leftHigh = false;
                                            let rightHigh = false;

                                            let x = 0;
                                            let y = 0;

                                            if (d == 0) {
                                                ctx.textAlign = 'left';
                                                ctx.textBaseline = 'middle';
                                                x = m.x + 3;
                                                y = m.y;
                                            }
                                            else if (d == dataset.data.length - 1) {
                                                ctx.textAlign = 'right';
                                                ctx.textBaseline = 'middle';
                                                x = m.x - 3;
                                                y = m.y;
                                            }

                                            else {
                                                const prev = dataset.data[d - 1];
                                                const next = dataset.data[d + 1];

                                                if (prev >= current) {
                                                    leftHigh = true;
                                                }

                                                if (next >= current) {
                                                    rightHigh = true;
                                                }

                                                if (leftHigh || rightHigh) {
                                                    if (dataset.data[d] >= scaleBottomThreshold) {
                                                        //Draw Below
                                                        ctx.textAlign = 'center';
                                                        ctx.textBaseline = 'top';
                                                        x = m.x;
                                                        y = m.y + 2;
                                                    }
                                                    else {
                                                        //Draw Above
                                                        ctx.textAlign = 'center';
                                                        ctx.textBaseline = 'bottom';
                                                        x = m.x;
                                                        y = m.y - 2;
                                                    }
                                                }
                                                else {
                                                    if (dataset.data[d] > scaleTopThreshold) {
                                                        //Higher than drawing area, Draw below
                                                        ctx.textAlign = 'center';
                                                        ctx.textBaseline = 'top';
                                                        x = m.x;
                                                        y = m.y + 2;
                                                    }
                                                    else {
                                                        //Draw Above
                                                        ctx.textAlign = 'center';
                                                        ctx.textBaseline = 'bottom';
                                                        x = m.x;
                                                        y = m.y - 2;
                                                    }
                                                }

                                            }

                                            ctx.fillStyle = "#000";
                                            ctx.fillText(dataset.data[d], x, y);
                                        }
                                    }
                                }
                            }
                        }

                        else {
                            ctx.textAlign = 'right';
                            ctx.textBaseline = 'middle';
                            ctx.font="12px sans-serif";
                            for (var i = 0; i < dataset.data.length; i++) {
                                if (i == 0) {
                                    for (var key in dataset._meta) {
                                        if(dataset._meta[key].data[i]) {
                                            var model = dataset._meta[key].data[i]._model;
                                            ctx.fillStyle = 'white';
                                            ctx.fillRect(model.x - 100, model.y - 20, 100, 40);
                                            ctx.fillStyle = dataset.borderColor;
                                            ctx.fillText(dataset.data[i], model.x - 10, model.y);
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
            },
            tooltips:{
                callbacks:{
                    label:this.props.graphModifier.tooltipsLabel
                }
            }
        }
    };

    componentDidMount=()=>{
        if(typeof this.props.autoQuery != "undefined"){
            this.autoQuery(this.props.autoQuery,false);
        }
    }

    componentDidUpdate=(oldProps,oldState)=>{
        if(this.state.autoQuery != this.props.autoQuery){
            this.autoQuery(this.props.autoQuery,true);
        }
    }

    onToggleSettings=()=>{
        this.setState({showSettings:!this.state.showSettings});
    }

    onChangeSetting=(value,label,index)=>{
        if(label == "borderColor" || label == "pointBackgroundColor"){
            let color=defaultColor;
            let colorIndex=0;
            for(var i=0; i<this.state.settings.length; i++){
                if(this.state.settings[i].ref == label){
                    color=this.state.settings[i].value;
                    colorIndex=i;
                }
            }
            this.setState({step:2,colorIndex:colorIndex,color:color});
        }
        else{
            let settings = this.state.settings;
            for(var j=0; j<settings.length; j++){
                if(settings[j].ref == label){
                    settings[j].value= value;
                }
            }
            this.setState({settings:settings});
        }
    }

    onChangeColor=(color)=>{
        this.setState({color:color.hex});
    }

    onSelectColor=()=>{
        let settings = this.state.settings;
        settings[this.state.colorIndex].value=this.state.color;
        if(this.state.colorIndex == 0){
            settings[5].value = this.state.color;
        }
        this.setState({settings:settings,step:0});
    }

    goToStep=(step)=>{
        const nextStep = parseInt(step);
        if(nextStep == 0){
            this.setState({graphData:{datasets:[], labels:[]},addData:false});
            if(this.props.onReset){
                this.props.onReset();
            }
        }
        this.setState({step:nextStep,error:""});
    }

    onValidate=()=>{
        this.setState({error:""});
        let input = this.props.content.input;
        let label = "";
        let data = {};
        let query = {};
        for(var i=0; i<input.length; i++){
            const item = input[i];
            const userInput = this.refs[item.ref].validate();
            if(!userInput.valid){
                this.setState({error:userInput.value});
                return 0;
            }
            data[item.ref]=userInput.value;
            query[item.ref]=userInput;

            if(item.ref == "endDate"){
                //Always comes with a startDate
                const startDate=this.refs['startDate'].validate();
                if(moment(userInput.value).isBefore(startDate.value)){
                    this.setState({error:"End Date cannot be before Start Date"});
                    return 0;
                }
            }
            label = label + ((i>0) ? " | " : "") + ((userInput.option) ? userInput.option.label : ((moment(userInput.value,'YYYY-MM-DD',true).isValid()) ? moment(userInput.value).format("DD-MM-YY") : userInput.value));
        }

        let datasets = this.state.graphData.datasets;
        for(var d=0; d<datasets.length; d++){
            if(datasets[d].label == label){
                this.setState({error:label + " has already been added"});
                return 0;
            }
        }

        data.url = this.props.content.url;
        data.label=label;

        this.setState({loading:true,loadText:"Loading..."});
        this.getContent(data,query);
    }

    autoQuery=(params,reset)=>{
        this.setState({loading:true,loadText:"Loading...",error:"",autoQuery:params});

        if(reset){
            this.setState({graphData:{datasets:[], labels:[]}});
            if(this.props.onReset){
                this.props.onReset();
            }
        }

        for(var i=0; i<params.content.length; i++){
            this.getContent(params.content[i].data,params.content[i].query);
        }
    }

    getContent=(data,query)=>{
        u.post({
            url:data.url,
            data:data,
            success:(callback)=>{
                let graphData = this.state.graphData;
                if(graphData.labels.length == 0){
                    graphData.labels = callback.xAxis;
                }
                const queryType = (data.queryType == "averageOccupancy" || data.queryType == "averageBookings") ? "mean" : "normal";

                if(callback.yAxis){
                    graphData.datasets.push(this.constructGraph(callback,queryType,data.label,data.settings));
                }
                else if(callback.yAxes){
                    for(var i=0; i<callback.yAxes.length; i++){
                        let moddedData = Object.assign({},callback);
                        moddedData.yAxis = moddedData.yAxes[i].value;
                        graphData.datasets.push(this.constructGraph(moddedData,queryType,moddedData.yAxes[i].label,data.settings));
                    }
                }

                graphData.datasets.sort(function(a,b){
                    if(a.label < b.label) return -1;
                    if(a.label > b.label) return 1;
                    return 0;
                });

                this.setState({graphData:graphData,step:1,error:"",loading:false,redraw:true,addData:false});

                if(this.props.onData){
                    this.props.onData(query,callback);
                }
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    constructGraph=(callback,queryType,label,autoSettings)=>{
        let settings=(autoSettings) ? autoSettings : this.state.settings;

        let data={
            pointBorderWidth:0,
        };

        for(var i=0; i<settings.length; i++){
            const settingValue = settings[i].value;
            data[settings[i].ref] = (settingValue == "true" || settingValue == "false") ? (settingValue == "true") : settingValue;
        }

        const bg = u.hexToRgb(data.borderColor);

        data.backgroundColor = "rgba("+bg.r+","+bg.g+","+bg.b+",0.5)";
        data.pointBorderColor=data.pointBackgroundColor;
        data.pointHoverRadius=parseInt(data.pointRadius) + 1;
        data.queryType=queryType;

        if(data.lineType == "solid" || data.lineType == "dotted"){
            data.lineTension = 0;
        }

        if(data.lineType == "dotted" || data.lineType == "dottedCurve"){
            data.borderDash=[5,5];
        }

        data.label = label;
        data.data = callback.yAxis;
        return data;
    }

    onAddDataset=()=>{
        this.setState({step:0,addData:true});
    }

    onLoading=(loading,loadText)=>{
        this.setState({loading:loading,loadText:loadText,error:""});
    }

    onError=(error)=>{
        this.setState({error:error});
    }

    render=()=>{
        const content = this.props.content;
        const miniMode= (typeof this.props.autoQuery != "undefined");

        return (
            <div className={"report-container" + ((miniMode) ? " mini-mode" : "")}>

                {
                    (miniMode)
                        ?
                        <div className="report-mini-header">{this.props.autoQuery.label}</div>
                        :
                        <div className="report-header">
                            <div className="report-icon">
                                <img src={(content.image) ? content.image : "/images/reports/analytics.png"}/>
                            </div>
                            <h3 className="report-title">{content.title}</h3>
                        </div>

                }

                <Step active={(this.state.step == 0)}>
                    <div style={{position:"relative"}}>
                        <div>
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <div className="report-error">{this.state.error}</div>
                            <div className="report-description">{content.description}</div>
                            <div className="report-input">
                                {
                                    content.input.map(
                                        (item,index)=>{
                                            const lock = (this.state.addData && item.lock);
                                            return (<ReportInputItem key={index} index={index+""} ref={item.ref} enabled={true} lock={lock} content={item} onChange={this.props.onChangeInput}/>)
                                        }
                                    )
                                }
                                <div>
                                    {
                                        (this.state.showSettings)
                                            ?
                                            <div>
                                                {
                                                    this.state.settings.map(
                                                        (item,index)=>{
                                                            return (
                                                                <ReportInputItem key={index} ref={item.ref} content={item} onChange={this.onChangeSetting}/>
                                                            )
                                                        }
                                                    )
                                                }
                                                <TextButton onClick={this.onToggleSettings}>Hide Advance</TextButton>
                                            </div>
                                            :
                                            (this.props.graphType == "line")
                                                ?
                                                <TextButton onClick={this.onToggleSettings}>Show Advance</TextButton>
                                                :
                                                ""
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="report-buttons">
                            {
                                (this.state.addData)
                                    ?
                                    <Button index="1" onClick={this.goToStep} type="medium">Back</Button>
                                    :
                                    (
                                        (this.props.onDownload)
                                            ?
                                            <Button type="medium" onClick={this.props.onDownload}>Download</Button>
                                            :
                                            <div/>
                                    )

                            }
                            <Button onClick={this.onValidate} type="medium">{(this.state.addData) ? "Add Dataset" : "Go"}</Button>
                        </div>
                    </div>
                </Step>

                <Step active={(this.state.step == 1)}>
                    <div className="report-content">
                        <div className="report-graph">
                            <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                            <div style={{maxWidth:"1500px",margin:"auto"}}>
                                <div className="mobile-hide" style={{position:"absolute",fontWeight:"bold",fontSize:"10px"}}>({content.quantifier})</div>
                                {
                                    (this.props.graphType == "line")
                                        ?
                                        <Line data={this.state.graphData} options={this.state.options} redraw/>
                                        :
                                        ""
                                }
                                {
                                    (this.props.graphType == "bar")
                                        ?
                                        <Bar data={this.state.graphData} options={this.state.options} redraw/>
                                        :
                                        ""
                                }
                            </div>
                            {
                                (this.props.additionalText)
                                    ?
                                    <div className="report-addon-container">
                                        {
                                            this.props.additionalText.map(
                                                (item,index)=>{
                                                    return <div className="report-addon-item" key={index}><b>{item}</b></div>
                                                }
                                            )
                                        }
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                        {
                            (miniMode)
                                ?
                                ""
                                :
                                <div className="report-buttons">
                                    <Button onClick={this.goToStep} index="0" type="medium">Reset</Button>
                                    {
                                        (this.props.graphType == "line")
                                            ?
                                            <Button onClick={this.onAddDataset} type="medium">Add Dataset</Button>
                                            :
                                            ""
                                    }
                                </div>
                        }
                    </div>
                </Step>

                <Step active={(this.state.step == 2)}>
                    <div>
                        <h3>Select Color</h3>
                        <div style={{position:"relative",display:"inline-block",margin:"auto"}}>
                            <SketchPicker color={this.state.color} disableAlpha={true} presetColor={presetColors} width="300px" onChange={this.onChangeColor}/>
                        </div>
                        <div className="report-buttons">
                            <Button type="medium" onClick={this.onSelectColor}>Choose</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}
GraphReport.propTypes={
    content:PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        input: PropTypes.array.isRequired,
        image: PropTypes.string,
    }),
    onChangeInput:PropTypes.func,
    onData:PropTypes.func,
    onDownload:PropTypes.func,
    additionalText:PropTypes.array,
    autoQuery:PropTypes.object,
    smallMode:PropTypes.bool,
    graphType:PropTypes.string,
    graphModifier:PropTypes.object,
};
GraphReport.defaultProps={
    graphType:"line",
};

export class ReportInputItem extends React.Component{

    validate=()=>{
        return this.refs['input'].validate();
    }

    render=()=>{
        const content=this.props.content;
        const enabled = (typeof this.props.enabled == "undefined") ? true : this.props.enabled;
        let rules = content.rules;
        if(this.props.lock){
            rules.lockDate=true;
            rules.lockMonth=true;
        }

        return (
            <div className="report-input-item">
                <div className="report-input-label">{content.label}:</div>
                <div className="report-input-value">
                    {
                        (content.type=="select")
                            ?
                            <Select ref="input" label={content.label} field={content.ref} index={this.props.index} values={{enabled:!this.props.lock,value:content.value,options:content.options}} rules={content.rules} onChange={this.props.onChange}/>
                            :
                            ""
                    }
                    {
                        (content.type=="date")
                            ?
                            <Date ref="input" label={content.label} field={content.ref} index={this.props.index} values={{enabled:enabled,value:content.value}} range={content.range} rules={rules} onChange={this.props.onChange}/>
                            :
                            ""
                    }
                    {
                        (content.type=="time")
                            ?
                            <Time ref="input" label={content.label} field={content.ref} index={this.props.index} values={{enabled:enabled,value:content.value}} rules={rules} onChange={this.props.onChange}/>
                            :
                            ""
                    }
                    {
                        (content.type=="color")
                            ?
                            <Color ref="input" label={content.ref} color={content.value} index={this.props.index} onChange={this.props.onChange}/>
                            :
                            ""
                    }
                </div>
            </div>
        )
    }
}
ReportInputItem.propTypes={
    content:PropTypes.object.isRequired,
    onChange:PropTypes.func
};

export class PieChart extends React.Component{

    state={
        error:"",
        pieData:{
            datasets:[
                {
                    data: this.props.content.data,
                    borderColor: "#fff",
                    borderWidth: [2, 2, 2],
                    hoverBorderColor: "#fff",
                    hoverBorderWidth: [2, 2, 2]
                }
            ],
            labels:this.props.content.labels,
        },
        options:{
            cutoutPercentage:(this.props.content.pie) ? 0 : 50,
            rotation:-0.5 * Math.PI,
            circumference: 2 * Math.PI,
            animation: {
                animateRotate: true,
                animateScale: false
            },
            tooltips:{
                enabled:(typeof this.props.content.tooltips != "undefined") ? this.props.content.tooltips : true,
            },
            legend:{
                display:this.props.content.showLegend
            }
        }
    };

    static getDerivedStateFromProps(props,state){
        if(state.content != props.content){
            let pieData = state.pieData;
            let options = state.options;

            const backgroundColor = (props.content.backgroundColor) ? props.content.backgroundColor : presetColors;
            let backgroundHover = backgroundColor.map((color)=>{
                const a = u.hexToRgb(color);
                return "rgba(" + a.r + "," + a.g + "," + a.b + ",0.5)";
            });

            pieData.datasets[0].data = props.content.data;
            pieData.datasets[0].backgroundColor=backgroundColor;
            pieData.datasets[0].hoverBackgroundColor=backgroundHover;
            pieData.labels=props.content.labels;
            options.tooltips.enabled = (typeof props.content.tooltips != "undefined") ? props.content.tooltips : true;
            options.cutoutPercentage=(props.content.pie) ? 0 : 50;

            state.pieData=pieData;
            state.options=options;
            state.content=props.content;
        }
        return state;
    }

    onClick=(e)=>{
        //e.preventDefault();
        //e.stopPropagation();
    }

    render=()=>{
        return (
            <div className={"pie-chart" + ((this.props.className) ?  " " + this.props.className : "") } onClick={this.onClick}>
                <Doughnut options={this.state.options} data={this.state.pieData}/>
            </div>
        )
    }
}
PieChart.propTypes= {
    content: PropTypes.shape({
        showLegend: PropTypes.bool,
        backgroundColor: PropTypes.array,
        data: PropTypes.array,
        labels: PropTypes.array,
        tooltips: PropTypes.bool,
        pie:PropTypes.bool,
    }).isRequired
};
